import Image from "../../components/image";
import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { ContactForm } from "../../components/contact-form";
import { ContactFaq } from "../../components/contact-faq";
import { SectionHeading } from "../../components/site-shell";
import { createMetadata, serializeJsonLd } from "../../lib/seo";
import { siteConfig } from "../../lib/site-config";

export const metadata = createMetadata({
  title: "免费增长诊断与出海咨询",
  description:
    "预约免费初步增长诊断，梳理企业品牌、官网或独立站、内容、SEO/GEO、产品出海与海外获客路径中的关键问题和优先事项。",
  path: "/contact",
  keywords: [
    "免费增长诊断",
    "企业增长诊断",
    "品牌增长咨询",
    "SEO咨询",
    "GEO咨询",
    "AI搜索优化咨询",
    "企业官网咨询",
    "网站增长诊断",
    "独立站诊断",
    "产品出海咨询",
    "海外增长诊断",
    "制造业出海咨询",
    "外贸营销咨询",
    "海外营销咨询",
  ],
  image: "/assets/earth.jpg",
});

const faqs = [
  [
    "预约增长诊断需要收费吗？",
    "初步增长诊断用于了解企业现状、目标市场与当前关键问题，判断双方是否适合进一步合作，不收取费用。",
  ],
  [
    "提交后多久能联系我？",
    "我们会在 24 小时内联系您，确认沟通时间，并说明需要准备的产品、市场或现有网站资料。",
  ],
  [
    "诊断会直接给出报价吗？",
    "我们会先确认问题、目标与项目边界。若适合继续合作，将按阶段提供服务范围、交付内容、建议周期与费用说明。",
  ],
  [
    "可以线上沟通吗？",
    "可以。我们支持线上会议；如项目需要，也可根据双方安排进行线下沟通。",
  ],
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(([question, answer]) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: {
      "@type": "Answer",
      text: answer,
    },
  })),
};

export default function ContactPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(faqJsonLd) }}
      />
      <section className="contact-booking">
        <div className="section-shell contact-booking-layout">
          <header className="contact-intro">
            <h1>
              <span>预约免费</span>
              <span>企业增长诊断</span>
            </h1>
            <p>
              从产品优势、目标市场和现有基础出发，梳理品牌、网站、内容、搜索与获客路径的优先事项。
            </p>
            <p className="contact-intro-meta">
              免费初步诊断 · 24 小时内联系 · 支持线上沟通
            </p>
          </header>
          <div className="form-panel">
            <div className="form-panel-heading">
              <h2>开始填写</h2>
              <p>请提供基本业务信息，带 * 的项目为必填项。</p>
            </div>
            <ContactForm />
          </div>
          <aside className="contact-panel">
            <h2>联系我们</h2>
            <p>
              您可以通过以下方式联系增长顾问，或提交业务信息，我们将与您确认适合的沟通方式与诊断安排。
            </p>
            <div className="contact-list">
              <div className="contact-item">
                <div className="contact-item-icon">
                  <Phone />
                </div>
                <div>
                  <h3>电话</h3>
                  <p>{siteConfig.contact.phone.display}</p>
                  <p>{siteConfig.contact.businessHours}</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item-icon">
                  <MessageCircle />
                </div>
                <div>
                  <h3>微信</h3>
                  <p>{siteConfig.contact.wechat}</p>
                  <p>添加时请备注公司名称与来意</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item-icon">
                  <Mail />
                </div>
                <div>
                  <h3>邮箱</h3>
                  <p>{siteConfig.contact.email}</p>
                  <p>{siteConfig.contact.responseTime}</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item-icon">
                  <MapPin />
                </div>
                <div>
                  <h3>地址</h3>
                  <p>{siteConfig.contact.address}</p>
                </div>
              </div>
            </div>
            <Image
              src={siteConfig.contact.qrCode.src}
              alt={siteConfig.contact.qrCode.alt}
              width={104}
              height={104}
            />
            <div className="map-panel" />
          </aside>
        </div>
      </section>
      <section className="section-muted section-block-sm">
        <div className="section-shell">
          <SectionHeading title="常见问题" />
          <ContactFaq items={faqs} />
        </div>
      </section>
    </>
  );
}
